export const customerPanDetailsFormFields = [
  {
    type: 'text',
    name: 'panNumber',
    label: 'PAN Number',
    placeholder: 'Enter Valid PAN Number',
    example: 'Eg: NVLNK4546Q',
    maxLength: 10,
    autoCapitalize: 'characters',
    config: {
      required: true,
    },
  },
  {
    type: 'date',
    name: 'dob',
    label: 'Date of Birth',
    example: 'Eg: 20/02/1996',
    value: new Date(),
    config: {
      required: true,
      maxDate: new Date(),
    },
  },
]
